import { isNil } from 'lodash';
import { API } from '@shared/types/api';

/**
 * The ids of every `RELATED_CARD` component referenced by a cross-workflow
 * (`matchesRelatedEntity`) filter in this criteria, across both top-level filters and groups.
 *
 * Saved criteria only carries component ids, so a nested filter can't be decoded until the related
 * workflow template it points at has loaded. This tells `ControlsProvider` which templates to
 * fetch, without having to speculatively load one per related-card component on the workflow.
 */
export function getRelatedEntityFilterComponentIds(
  criteria: API.CollectionCriteriaFragment | null | undefined,
): string[] {
  if (isNil(criteria)) {
    return [];
  }
  const groupFilters = (criteria.groups ?? []).flatMap(group => group.filterByComponents ?? []);
  const componentIds = [...(criteria.filterByComponents ?? []), ...groupFilters]
    .filter(filter => !isNil(filter.value.matchesRelatedEntity))
    .map(filter => filter.componentId);
  return Array.from(new Set(componentIds));
}
